import { useLanguage } from "@/contexts/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher() {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();

  const getLanguageDisplay = (lang: string) => {
    switch (lang) {
      case 'en':
        return { native: 'English', code: 'EN' };
      case 'de':
        return { native: 'Deutsch', code: 'DE' };
      case 'fr':
        return { native: 'Français', code: 'FR' };
      case 'it':
        return { native: 'Italiano', code: 'IT' };
      default:
        return { native: lang, code: lang.toUpperCase() };
    }
  };

  const currentLang = getLanguageDisplay(currentLanguage);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="text-xs font-medium px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          data-testid="button-language-switcher"
          aria-label={`Language: ${currentLang.native}`}
          aria-haspopup="menu"
        >
          {currentLanguage.toUpperCase()}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[200px] p-1">
        {availableLanguages.map((lang, index) => {
          const display = getLanguageDisplay(lang);
          return (
            <div key={lang}>
              <button
                onClick={() => changeLanguage(lang)}
                className={`w-full text-left px-3 py-2 text-sm rounded-md transition-colors ${
                  currentLanguage === lang 
                    ? 'bg-gray-100 text-gray-900 font-medium' 
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
                data-testid={`option-language-${lang}`}
                aria-label={`Switch to ${display.native}`}
                lang={lang}
              >
                {display.native} ({display.code})
              </button>
              {index < availableLanguages.length - 1 && (
                <div className="h-px bg-gray-200 my-1" />
              )}
            </div>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}